import * as _ from 'underscore'
import BigNumber from 'bignumber.js'
BigNumber.clone()
export class CustomBigNumber {
  private _value: any
  private _minDecimalPlaces = 2
  private _maxDecimalPlaces = 8

  public constructor(value: any) {
    const format = {
      decimalSeparator: '.',
      groupSeparator: ',',
      groupSize: 3,
    }

    BigNumber.config({
      FORMAT: format,
      ROUNDING_MODE: BigNumber.ROUND_HALF_UP,
      DECIMAL_PLACES: this._maxDecimalPlaces,
    })

    this._value = value == '' || value == '-' || value == null ? new BigNumber(0) : new BigNumber(value)
  }

  public init(): any {
    return this._value
  }

  public toFormat(): string {
    let decimalPlaces: number = this._value.decimalPlaces()

    if (decimalPlaces == this._maxDecimalPlaces) {
      decimalPlaces = 4
    }

    if (decimalPlaces < this._minDecimalPlaces) {
      decimalPlaces = this._minDecimalPlaces
    }

    if (decimalPlaces > this._maxDecimalPlaces) {
      decimalPlaces = this._maxDecimalPlaces
    }

    return this._value.toFormat(decimalPlaces)
  }
}
